import state from '@/vuex/arquivos-documento/state.js'
import getters from '@/vuex/arquivos-documento/getters.js'
import mutations from '@/vuex/arquivos-documento/mutations.js'
import actions from '@/vuex/arquivos-documento/actions.js'

const module = {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}

export default module
